(function() {
    'use strict';

    angular.module("imApp").factory("consignmentDeliveryService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1997,
                    parameters: parms || {}
                });
            },
            listDeliveryMethods: function (parms) {
                return $ihttp.post({
                    method: 1978,
                    parameters: parms || {}
                });
            },
            listConsignmentDeliveries: function (parms) {
                return $ihttp.post({
                    method: 1976,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
